import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import ClientForm from "../components/ClientForm";
import Preloader from "../components/Preloader";
import {
  loadClient,
  removeClient, editCardRequest, loadClientAction, editCardError,
} from "../actions/clientsActions";
import { loadUsers } from "../actions/userActions";
import { ELEVATOR } from "../constants/routes";
import {
  parseUrl,
  translateServerError,
  prepareUsersForSelect, createRedirectUrlFromType
} from "../helpers/core";
import { updateTableOfChanging } from "../actions/updateTableOfChanging";
import editCardHttpHandler, {
  Contact,
  EditCardRequest, GrainVolume
} from "../apiClient/Card/Edit";

class ElevatorDetailPage extends Component {
  id = this.props.location.search && parseUrl(this.props.location.search).id;

  componentWillMount() {

    if (this.id) {
      this.props.loadClient(this.id);
    }
    this.props.loadUsers();
  }

  onClientChange = data => {
    this.props.changeClient(data);
  };

  onClientRemove = () => {
    if (
      !window.confirm(
        "Вы уверены, что хотите удалить Элеватор? Действие необратимо"
      )
    )
      return;
    this.props.removeClient(this.id);
  };

  render() {
    if (!this.id) {
      return (
        <div className="container">
          <h4>Некорректный адрес.</h4>
          <p>
            Рекомендуем перейти к <Link to={ELEVATOR}>списку элеваторов</Link>.
          </p>
        </div>
      );
    }


    const {
      loading,
      elevator,
      initData,
      error,
      priceUpdating,
      modules,
      users,
      updateTableOfChanging,
      changes
    } = this.props;
    const userForSelect = users.length ? prepareUsersForSelect(users) : [];

    if (loading) {
      return <Preloader />;
    }

    if (!loading && !elevator) {
      return (
        <div className="container">
          <h4>Элеватор успешно удален.</h4>
          <p>
            Перейти к <Link to={ELEVATOR}>списку элеваторов</Link>.
          </p>
        </div>
      );
    }

    if (elevator.type !== 3) {
      window.location.href = createRedirectUrlFromType(
          elevator.id,
          parseInt(elevator.type)
        );
    }

    return (
      <ClientForm
        isEditMode
        client={elevator}
        initData={initData}
        moveCultureToHistory={() => {}}
        type={elevator.type || ""}
        onSubmit={this.onClientChange}
        onRemove={this.onClientRemove}
        serverError={error}
        priceUpdating={priceUpdating}
        showCalleeAsign={modules.assign_call}
        showDeleteAction={modules.can_delete}
		showInWorkButton={false}
		showCancelInWorkButton={false}
        users={userForSelect}
        updateTableOfChanging={updateTableOfChanging}
        changes={changes}
      />
    );
  }
}
const editCard = (dispatch, data) => {

  dispatch(editCardRequest);

  editCardHttpHandler.edit(data.client.id, new EditCardRequest(
      data.client.type || null,
      data.client.name || null,
      data.client.email || null,
      data.client.address || null,
      data.client.lat || null,
      data.client.lon || null,
      data.client.geo_id || null,
      data.client.area_full || null,
      data.client.will_callee_id || null,
      data.client.date_will_call || null,
      data.client.call_aim || null,
      data.client.additional_info || null,
      data.client.contract || false,
      data.client.vat || 1,
      data.client.websites,
      data.client.filials.map((filialData) => filialData.id),
      data.client.categories,
      data.client.contacts.map((contactData) => new Contact(
          contactData.name,
          contactData.phone,
          contactData.email,
          contactData.isVisible,
      )),
      data.client.cultures.map((grainData) => new GrainVolume(
          grainData.culture_id,
          grainData.price,
          grainData.volume,
          grainData.quality_comment,
      )),
      data.client.date_called || null
      )
  ).subscribe(
      (response) => {
        loadClientAction(data.client.id, dispatch);
      },
      (error) => {
        dispatch(editCardError(error.error.join("\n")));
      })
}

ElevatorDetailPage.propTypes = {
  elevator: PropTypes.object,
  location: PropTypes.object,
  initData: PropTypes.object,
  loading: PropTypes.bool,
  priceUpdating: PropTypes.bool,
  loadClient: PropTypes.func.isRequired,
  changeClient: PropTypes.func.isRequired,
  removeClient: PropTypes.func.isRequired,
  loadUsers: PropTypes.func.isRequired,
  error: PropTypes.string,
  modules: PropTypes.object,
  users: PropTypes.array
};

const mapStateToProps = state => ({
  changes: state.changing.dataOfChanging,
  elevator: state.clients.list[0],
  loading: state.clients.loading,
  priceUpdating: state.clients.priceUpdating,
  initData: state.webInterface.initData,
  error: translateServerError(state.clients.error),
  modules: state.webInterface.initData
    ? state.webInterface.initData.available_modules
    : {},
  users: state.users.list
});

const mapDispatchToProps = dispatch => ({
  loadClient: id => dispatch(loadClient(id)),
  changeClient: data => editCard(dispatch, data),
  removeClient: id => dispatch(removeClient(id)),
  loadUsers: () => dispatch(loadUsers()),
  updateTableOfChanging: id => dispatch(updateTableOfChanging(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ElevatorDetailPage);



// WEBPACK FOOTER //
// ./containers/ElevatorDetailPage.js